import React from "react";
import styled from "styled-components";
import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";

// Styled Components
const WorkWrapper = styled.div`
  padding: 50px 0px 50px;
  max-width: 1536px;
  margin: 0 auto;
  padding-left: 20px;
  padding-right: 20px;
  transition: all 0.3s ease-out;

  @media (max-width: 1200px) {
    padding: 40px 20px 40px;
  }

  @media (max-width: 1024px) {
    text-align: center;
    padding: 30px 20px 30px;
  }

  @media (max-width: 768px) {
    padding: 25px 15px 25px;
  }

  @media (max-width: 480px) {
    padding: 20px 10px 20px;
  }
`;

const WorkHeader = styled.div`
  font-weight: bold;
  font-size: 50px;
  text-align: center;
  color: ${props => props.theme?.palette?.text?.main || '#000000'};
  margin: 0;
  padding-bottom: 30px;
  transition: all 0.3s ease-out;
  animation: fadeInUp 0.8s ease-out;

  @keyframes fadeInUp {
    from {
      opacity: 0;
      transform: translateY(30px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @media (max-width: 1200px) {
    font-size: 45px;
    padding-bottom: 25px;
  }

  @media (max-width: 1024px) {
    font-size: 42px;
    padding-bottom: 20px;
  }

  @media (max-width: 768px) {
    font-size: 38px;
    padding-bottom: 15px;
  }

  @media (max-width: 480px) {
    font-size: 32px;
    padding-bottom: 12px;
  }

  @media (max-width: 360px) {
    font-size: 28px;
    padding-bottom: 10px;
  }
`;

const PawprintSpan = styled.span`
  color: ${props => props.theme?.palette?.primary?.main || '#FF8533'};
  text-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);
  transition: all 0.3s ease-out;

  &:hover {
    text-shadow: 0px 6px 15px rgba(0, 0, 0, 0.25);
  }
`;

const WorkText = styled.div`
  color: #000000;
  font-weight: 500;
  font-size: 23px;
  text-align: center;
  line-height: 38px;
  letter-spacing: -0.011em;
  transition: all 0.3s ease-out;
  animation: fadeInUp 0.8s ease-out 0.2s both;

  @keyframes fadeInUp {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  p {
    margin: 0;
    transition: all 0.3s ease-out;

    &:hover {
      text-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
    }
  }

  @media (max-width: 1200px) {
    font-size: 22px;
    line-height: 36px;
  }

  @media (max-width: 1024px) {
    font-size: 20px;
    line-height: 34px;
  }

  @media (max-width: 768px) {
    font-size: 18px;
    line-height: 30px;
  }

  @media (max-width: 480px) {
    font-size: 16px;
    line-height: 28px;
  }

  @media (max-width: 360px) {
    font-size: 15px;
    line-height: 26px;
  }
`;

function HowWork() {
  const theme = useTheme();

  return (
    <WorkWrapper>
      <WorkHeader theme={theme}>
        How <PawprintSpan theme={theme}>PawprintID®</PawprintSpan> Works
      </WorkHeader>
      <WorkText>
        <p>
          You can create an account in minutes, and you're able to manage your
          pet's records from any device.
          <br />
          In the event that your pet becomes ill or needs immediate medical
          attention, PawprintID® provides you with an easy way to share
          critical details about your furry friend with a local animal hospital
          or specialist.
        </p>
      </WorkText>
    </WorkWrapper>
  );
}

export default HowWork;
